__turbopack_context__.v({
  "badge": "kLaWoq_badge",
  "badgeButton": "kLaWoq_badgeButton",
  "iconWrapper": "kLaWoq_iconWrapper",
});
